import React from 'react';
import styled from 'styled-components/macro';
import { isEmpty } from 'lodash';
import scaleSize from 'utils/scale-size';
import { Focusable } from 'components/navigation';
import config from 'config';

export const PROFILE_ITEM_WIDTH = scaleSize(355);
export const PROFILE_ITEM_MARGIN = scaleSize(20);

// TODO: change to ListItem type
const StyledProfileItem = styled(Focusable)`
  width: ${PROFILE_ITEM_WIDTH}px;
  height: ${scaleSize(400)}px;
  display: inline-block;
  text-align: center;
  margin-right: ${PROFILE_ITEM_MARGIN}px;
  margin-bottom: ${scaleSize(150)}px;
  box-sizing: border-box;
  border-radius: ${scaleSize(12)}px;
  background-color: ${({ theme }) => theme.imagePlaceholder};
  transform: translate3d(0, 0, 0);
  transition: ${config.withAnimation ? 'transform 0.2s' : 'none'};
  padding: 0 ${scaleSize(30)}px;
  cursor: pointer;
  white-space: normal;

  &:hover {
    transform: translate3d(0, -${scaleSize(10)}px, 0);
  }

  &:focus {
    background-color: ${({ theme }) => theme.activeColor};
    transform: translate3d(0, -${scaleSize(20)}px, 0);

    & > span {
      color: ${({ theme }) => theme.focusedTextColor};
    }

    & > i {
      color: ${({ theme }) => theme.focusedTextColor};
      border-color: ${({ theme }) => theme.focusedTextColor};
    }
  }
`;

const ProfileItemTitle = styled.span`
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(48)}px;
  letter-spacing: ${scaleSize(-0.33)}px;
  height: ${scaleSize(34)}px;
  margin-top: ${scaleSize(100)}px;
  margin-bottom: ${scaleSize(5)}px;
  color: ${({ theme }) => theme.defaultColor};
  font-family: RobotoCondensedBold, sans-serif;
  font-weight: bold;
  display: block;
  text-align: center;
`;

interface IProfileItemMetadata {
  hasContent?: boolean;
}

const ProfileItemMetadata = styled.i<IProfileItemMetadata>`
  position: relative;
  top: ${scaleSize(110)}px;
  min-width: ${scaleSize(80)}px;
  border-radius: ${scaleSize(4)}px;
  border-style: solid;
  border-width: ${({ hasContent }) => (hasContent ? 0 : `${scaleSize(4)}px`)};
  border-color: ${({ theme, hasContent }) => (hasContent ? 'none' : theme.submenuActiveColor)};
  font-size: ${scaleSize(24)}px;
  line-height: 1.17;
  letter-spacing: ${scaleSize(-0.17)}px;
  color: ${({ theme }) => theme.secondaryTextColor};
  font-style: normal;
  display: inline-block;
  vertical-align: middle;
  font-family: 'RobotoRegular', sans-serif;
  font-weight: 500;
`;

const ProfileItem = ({ id, item, onFocus, onEnter, index }) => {
  const hasMetadataContent = !isEmpty(item.metadata);
  return (
    <StyledProfileItem
      id={id}
      onFocus={onFocus}
      onEnter={onEnter}
      // TODO: Focus and onEnter receivers different params
      payload={index}
      index={index}
      focusOnMouseEnter
    >
      <ProfileItemTitle>{item.name}</ProfileItemTitle>
      <ProfileItemMetadata hasContent={hasMetadataContent}>{item.metadata}</ProfileItemMetadata>
    </StyledProfileItem>
  );
};

export default ProfileItem;
